module.exports = __webpack_public_path__ + "img/Layer_16.fbb31236.png";